<template>
  <b-card class="cloud-card">
    <b-card-header
      class="text-danger font-weight-bold"
      v-if="option.value === 0"
      v-html="free_title"
    ></b-card-header>
    <b-card-header
      v-else
      class="font-weight-bold"
      :class="{
        'disabled-label': option.disabled,
        'text-info': !option.disabled,
      }"
      v-html="planName(option)"
    ></b-card-header>
    <hr class="mt-1" />
    <div v-if="option.value === 0">
      <b-card-text v-html="free_info"></b-card-text>
      <b-card-text class="text-center">
        <order-checkbox
          v-on:addproduct="selectPlan(option.value)"
          :wasChecked="freeCloudUsed || option.value === currentCloud.plan"
          :isChecked="option.value === plan"
          :product="option"
          :styles="styles"
          :text="free_price"
          :dontDisplayProductMandatory="true"
        >
        </order-checkbox>
        <p class="line-through">
          <span v-if="isAccountant || skpAccountantAdd">{{
            commaFormat(cloudOptions[71].net)
          }}</span>
          <span v-else-if="program === 'sam' && skpAdd">{{
            commaFormat(cloudOptions[80].net)
          }}</span>
          <span v-else>{{ commaFormat(cloudOptions[77].net) }}</span>
          zł netto/miesięcznie
        </p>
        <p class="text-danger text-center font-weight-bold">GRATIS</p>
      </b-card-text>
      <b-card-text v-if="option.value === plan">
        <hr class="mt-1" />
        <b-row>
          <div
            v-for="month in monthsPrepared"
            :key="month.value"
            class="float-left ml-2"
          >
            <order-checkbox
              v-on:addproduct="updateMonths(month)"
              :wasChecked="currentCloud.months.includes(month.value)"
              :isChecked="months.includes(month.value)"
              :product="month"
              :styles="styles"
              :text="month.text"
              :dontDisplayProductMandatory="true"
            ></order-checkbox>
          </div>
        </b-row>
      </b-card-text>
    </div>
    <div v-else>
      <b-card-text
        v-if="startOfYear"
        class="text-center"
        :class="{
          'disabled-label': option.disabled,
        }"
      >
        <order-checkbox
          v-on:addproduct="
            selectPlan(option.value + '_year', plan === option.value + '_year')
          "
          :wasChecked="plan === option.value + '_year'"
          :isChecked="plan === option.value + '_year'"
          :disabled="option.disabled"
          :product="option"
          :styles="styles"
          text="Abonament roczny"
          :dontDisplayProductMandatory="true"
        ></order-checkbox>
        <p class="line-through mb-0">
          {{ commaFormat(option.net * 12) }} zł netto/rok
        </p>
        <p
          class="mb-0"
          :class="{
            'text-danger': !option.disabled,
          }"
        >
          Rabat
          <span
            v-if="
              isAccountant &&
              cloudNeverHave &&
              isDiscount622_623 &&
              !this.isDiscount649 &&
              !this.isDiscount656_657
            "
          >
            50
          </span>
          <span v-else> 15 </span>
          %
        </p>
        <p
          class="font-weight-bold"
          :class="{
            'text-danger': !option.disabled,
          }"
        >
          {{ commaFormat(yearlyDiscount(option, option.net * 12)) }} zł
          netto/rok
        </p>
      </b-card-text>
      <b-card-text
        class="text-center"
        :class="{
          'disabled-label': option.disabled,
        }"
      >
        <order-checkbox
          v-on:addproduct="selectPlan(option.value)"
          :wasChecked="option.value === currentCloud.plan"
          :isChecked="option.value === plan"
          :disabled="option.disabled"
          :product="option"
          :styles="styles"
          text="Abonament miesięczny"
          :dontDisplayProductMandatory="true"
        >
        </order-checkbox>
        <p>
          <span v-if="option.oldNet > 0" class="text-danger line-through px-2"
            >{{ commaFormat(option.oldNet) }} zł</span
          >
          <span class="font-weight-bold">{{ commaFormat(option.net) }} zł</span>
          netto/miesiąc <br />
          <span v-if="option.oldNet > 0" class="small2"
            >(Najniższa cena z 30 dni przed obniżką:<br />
            {{ commaFormat(option.oldNet) }} zł netto/miesiąc)</span
          >
        </p>
      </b-card-text>
      <b-card-text
        v-if="option.value === plan || option.value === currentCloud.plan"
        class="mb-0"
      >
        <hr class="mt-1" />
        <p v-if="!isDiscount649 && !isDiscount656_657">
          Uwaga PROMOCJA! W abonamencie na minimum 6 miesięcy otrzymasz –
          <strong>
            <span v-if="isAccountant && cloudNeverHave && isDiscount622_623"
              >35</span
            ><span v-else>10</span>% RABATU </strong
          >, a w rocznym aż
          <strong>
            <span v-if="isAccountant && cloudNeverHave && isDiscount622_623"
              >50</span
            ><span v-else> 15 </span>% RABATU!
          </strong>
          <span v-if="isAccountant && cloudNeverHave && isDiscount622_623"
            >Promocja obowiązuje <strong>do 31.01.2023</strong></span
          >
        </p>
        <order-checkbox
          v-if="!startOfYear"
          v-on:addproduct="selectAll"
          :isChecked="allMonths"
          :product="allMonths === false"
          :styles="styles"
          :disabled="!isAnyMonthLeft"
          text="Zaznacz wszystkie miesiące"
          :dontDisplayProductMandatory="true"
        ></order-checkbox>

        <b-row>
          <b-col lg="5" class="px-2 pt-1">
            <div
              v-for="month in monthsPrepared.slice(0, 6)"
              :key="month.value"
              class="float-left my-0 w-100"
            >
              <order-checkbox
                v-on:addproduct="updateMonths(month)"
                :wasChecked="
                  currentCloud.months.includes(month.value) &&
                  currentCloud.plan == option.value
                "
                :isChecked="
                  months.includes(month.value) && plan == option.value
                "
                :disabled="month.disabled"
                :product="month"
                :styles="styles"
                :text="month.text"
                :dontDisplayProductMandatory="true"
              >
              </order-checkbox>
            </div>
          </b-col>
          <b-col lg="6" class="px-2 pt-1">
            <div
              v-for="month in monthsPrepared.slice(-6)"
              :key="month.value"
              class="float-left my-0 w-100"
            >
              <order-checkbox
                v-on:addproduct="updateMonths(month)"
                :wasChecked="
                  currentCloud.months.includes(month.value) &&
                  currentCloud.plan == option.value
                "
                :isChecked="
                  months.includes(month.value) && plan == option.value
                "
                :disabled="month.disabled"
                :product="month"
                :styles="styles"
                :text="month.text"
                :dontDisplayProductMandatory="true"
              >
              </order-checkbox>
            </div>
          </b-col>
        </b-row>
        <p v-if="plan === option.value" class="text-center mt-1 mb-0">
          Razem:
          <span v-if="oldTotal649 > 0" class="">
            <span class="text-danger line-through px-2"
              >{{ commaFormat(total) }} zł</span
            >
            netto <br />
            <span class="small">
              (Najniższa cena z 30 dni przed obniżką:
              {{ commaFormat(oldTotal649) }} zł netto)
            </span>
          </span>
          <span v-else>
            <span v-if="discountText === ''" class="font-weight-bold"
              >{{ commaFormat(total) }} zł netto</span
            >
            <span
              v-if="discountText != ''"
              class="font-weight-bold text-danger line-through"
              >{{ commaFormat(oldTotal) }} zł netto</span
            >
            <span
              v-if="discountText != ''"
              class="font-weight-bold info-text"
              style="font-size: 18px"
              >{{ commaFormat(total) }} zł netto</span
            >
          </span>
        </p>
        <p v-if="discountText != ''" class="text-center mt-1 mb-0">
          <span class="font-weight-bold text-danger">{{ discountText }}</span>
        </p>
        <p
          v-if="currentMonthWarning && !currentCloud.plan"
          class="pt-1 info-text small"
        >
          Czy na pewno chcesz zamówić usługę za kończący się miesiąc?
        </p>
      </b-card-text>
    </div>
  </b-card>
</template>

<script>
import { accountant, company } from '../../config/cloud';
import moment from 'moment';
import { mapGetters } from 'vuex';
import OrderCheckbox from './OrderCheckbox';

export default {
  name: 'OrderCloudPlan',
  components: { OrderCheckbox },
  props: {
    selectedPlan: {},
    selectedMonths: {},
    option: {},
    cloudNeverHave: { type: Boolean, default: false },
    isDiscount622_623: { type: Boolean, default: false },
    isDiscount649: { type: Boolean, default: false },
    isDiscount656_657: { type: Boolean, default: false },
    isAccountant: { type: Boolean, default: false },
    skpAdd: { default: null },
    skpCompanyAdd: { type: Boolean, default: false },
    skpAccountantAdd: { type: Boolean, default: false },
    cloudOptions: {},
    styles: {},
  },
  data() {
    return {
      allMonths: false,
      monthsInitial: [
        { value: 1, text: 'Styczeń' },
        { value: 2, text: 'Luty' },
        { value: 3, text: 'Marzec' },
        { value: 4, text: 'Kwiecień' },
        { value: 5, text: 'Maj' },
        { value: 6, text: 'Czerwiec' },
        { value: 7, text: 'Lipiec' },
        { value: 8, text: 'Sierpień' },
        { value: 9, text: 'Wrzesień' },
        { value: 10, text: 'Październik' },
        { value: 11, text: 'Listopad' },
        { value: 12, text: 'Grudzień' },
      ],
      monthEnding: process.env.MIX_MONTH_ENDING,
      months: [],
      discountText: '',
      oldTotal: 0,
      oldTotal649: 0,
    };
  },
  mounted() {
    this.months = this.selectedMonths;
  },
  computed: {
    ...mapGetters({
      currentCloud: 'order/currentCloud',
      cartProducts: 'order/getCartProducts',
      program: 'getProgram',
      freeCloudUsed: 'order/freeCloudUsed',
      cloudNeverHave2024: 'auth/cloudNeverHave2024',
    }),
    free_title() {
      return this.isAccountant ? accountant.free_title : company.free_title;
    },
    free_price() {
      return this.isAccountant ? accountant.free_price : company.free_price;
    },
    free_info() {
      return this.isAccountant ? accountant.free_info : company.free_info;
    },
    startOfYear() {
      return moment().format('M') <= 2;
    },
    plan() {
      return this.selectedPlan !== null
        ? this.selectedPlan
        : this.currentCloud.plan !== null
        ? this.currentCloud.plan
        : null;
    },
    total() {
      if (!this.plan) {
        return 0;
      }

      let planId = this.plan.toString().replace('_year', '');
      let that = this;
      let total = 0;
      this.months.forEach(function (month) {
        if (
          that.currentCloud.months.includes(month) &&
          that.cloudOptions[planId].net > that.currentCloud.price
        ) {
          total += that.cloudOptions[planId].net - that.currentCloud.price;
        } else {
          total += that.cloudOptions[planId].net;
        }
      });
      this.saveOldTotal649(0);
      if (
        (this.isDiscount649 || this.isDiscount656_657) &&
        [72, 77].includes(this.selectedPlan) &&
        12 - this.months.length ===
          new Date().getMonth() +
            (new Date().getDate() >= parseInt(this.monthEnding) ? 1 : 0)
      ) {
        return this.totalDiscount649(total);
      } else if (
        this.plan.toString().indexOf('year') !== -1 ||
        this.months.length === 12
      ) {
        return this.yearlyDiscount(this.cloudOptions[planId], total);
      } else if (this.months.length >= 6) {
        return this.monthlyDiscount(total);
      } else {
        this.clearDiscountText();
      }
      return total;
    },
    monthsPrepared() {
      let that = this;
      const currentMoment = moment();
      const currentMonth = currentMoment.month() + 1;

      if (this.plan === 0) {
        let allowedMonths = [];
        if (this.isAccountant) {
          allowedMonths = [
            Number(moment().format('M')),
            Number(moment().add(1, 'months').format('M')),
          ];
        } else {
          allowedMonths = [Number(moment().format('M'))];
        }

        return this.monthsInitial.filter((item) =>
          allowedMonths.includes(item.value)
        );
      }
      this.monthsInitial.forEach(function (item, index) {
        item.disabled =
          item.value < moment().format('M') ||
          (that.currentCloud.months.includes(item.value) &&
            that.option.value === that.currentCloud.plan) ||
          (currentMonth === parseInt(item.value) && currentMoment.date() >= 21);
      });
      return this.monthsInitial;
    },
    isAnyMonthLeft() {
      return (
        this.monthsPrepared.filter((item) => item.disabled === false).length > 0
      );
    },
    currentMonthWarning() {
      return (
        this.months.includes(parseInt(moment().format('M'))) &&
        parseInt(moment().format('D')) >= parseInt(this.monthEnding)
      );
    },
  },
  methods: {
    saveOldTotal649(oldTotal649) {
      this.oldTotal649 = oldTotal649;
    },
    selectAll(event) {
      if (event) {
        this.months = [];
        this.monthsPrepared
          .filter((item) => item.disabled === false)
          .forEach((item) => {
            this.updateMonths(item);
          });
        this.allMonths = true;
      } else {
        this.months = [];
        this.$store.commit('order/clearCloudMonths');
        this.$emit('selectmonths', this.months);
        this.$emit('updatetotal', this.total);
        this.allMonths = false;
      }
    },
    selectPlan(plan) {
      if (!this.option.disabled && plan !== this.currentCloud.plan) {
        if (plan !== this.plan) {
          this.$emit('selectplan', plan);
        } else {
          this.$emit('selectplan', null);
        }
        this.$store.commit('order/clearCloudMonths');
        this.months = [];
        this.$emit('selectmonths', []);
        this.$emit('updatetotal', this.total);
      }
    },
    updateMonths(month) {
      if (!month.disabled) {
        if (this.months.includes(month.value)) {
          this.months.splice(this.months.indexOf(month.value), 1);
        } else {
          this.months.push(month.value);
        }
      }
      this.$emit('selectplan', this.option.value);
      this.$emit('selectmonths', this.months);
      this.$emit('updatetotal', this.total);
    },
    commaFormat(value) {
      return Number(value).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    planName(value) {
      if (this.isAccountant || this.skpAccountantAdd) {
        return (
          value.text.split(' ')[0] + '<br>' + this.planDescription(value.text)
        );
      } else if (this.skpCompanyAdd) {
        return 'SKP24 Connect Firma';
      }

      return this.program.toUpperCase() + '24 Connect Firma';
    },
    planDescription(value) {
      return value.split(' - ')[1];
    },
    yearlyDiscount(option, total) {
      this.oldTotal = total;
      if (!this.isDiscount649 && !this.isDiscount656_657) {
        if (
          this.isAccountant &&
          this.cloudNeverHave &&
          this.isDiscount622_623
        ) {
          this.discountText = 'Przyznaliśmy 50% RABATU';
          return total - (total * 50) / 100;
        } else {
          this.discountText = 'Przyznaliśmy 15% RABATU';
          return total - (total * 15) / 100;
        }
      }
      return total;
    },
    monthlyDiscount(total) {
      this.oldTotal = total;
      if (this.isAccountant && this.cloudNeverHave && this.isDiscount622_623) {
        this.discountText = 'Przyznaliśmy 35% RABATU';
        return total - (total * 35) / 100;
      } else {
        this.discountText = 'Przyznaliśmy 10% RABATU';
        return total - (total * 10) / 100;
      }
    },
    totalDiscount649(total) {
      this.oldTotal = total;
      this.discountText = 'Przyznaliśmy 100% RABATU';
      this.saveOldTotal649(this.oldTotal);
      return 0;
    },
    clearDiscountText() {
      this.discountText = '';
    },
  },
};
</script>

<style scoped>
.cloud-card p {
  margin-bottom: 0.3rem;
}
</style>
